import styled, {css} from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {SelectList} from '@components/ui/select-atoms/SelectAtoms.tsx'

export const StyledDisplayValueWrapper = styled(Flexbox)`
    ${() => css`
        & svg {
            fill: none;
        }
    `}
`

export const StyledCountIndicator = styled.span`
    ${() => css`
        opacity: 0;
        transform: translateX(-10px);
        transition: all 0.2s ease-in-out;

        &.visible {
            opacity: 1;
            transform: translateX(0);
        }
    `}
`

export const StyledSelectListWrapper = styled(SelectList)`
    ${({theme}) => css`
        background-color: ${theme.palette.neutral.white};
        border: 1px solid ${theme.palette.neutral[200]};
        border-radius: 8px;
        box-shadow: ${theme.shadows.lg};
        margin-top: 4px;

        .spinner-container {
            margin: 10px 0;
        }
    `}
`

export const StyledSelectBaseListWrapper = styled(SelectList)`
    ${({theme}) => css`
        background-color: ${theme.palette.neutral.white};
        border: 1px solid ${theme.palette.neutral[200]};
        border-radius: 8px;
        box-shadow: ${theme.shadows.lg};
        margin-top: 4px;
        max-height: 200px;
    `}
`

export const StyledSelectNoResult = styled.div`
    ${({theme}) => css`
        color: ${theme.palette.neutral[800]};
        ${theme.typography.textSm};
        padding: ${theme.spacing * 2}px;
    `}
`
